import { render, staticRenderFns } from "./AdvantageSection.vue?vue&type=template&id=a4832e00&scoped=true"
import script from "./AdvantageSection.vue?vue&type=script&lang=js"
export * from "./AdvantageSection.vue?vue&type=script&lang=js"
import style0 from "./AdvantageSection.vue?vue&type=style&index=0&id=a4832e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4832e00",
  null
  
)

export default component.exports